import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import OtpInput from 'react-otp-input';

interface FormInputOtpProps {
  name: string;
  inputClassName: string;
  containerClassName: string;
  isRequired?: boolean;
  minMaxLength: number;
}

const defaultProps = {
  isRequired: false,
};

export const FormInputOtp: FC<FormInputOtpProps> = ({
  name,
  inputClassName,
  containerClassName,
  isRequired,
  minMaxLength,
}) => {
  const { control } = useFormContext();
  const { t } = useTranslation();
  const validationRules = {
    required: {
      value: isRequired || defaultProps.isRequired,
      message: t('validation.thisFieldIsRequired'),
    },
    minLength: {
      value: minMaxLength,
      message: `${t('validation.theNumberOfCharactersMustBeAtLeast')} ${minMaxLength}`,
    },
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={validationRules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <OtpInput
          onChange={(e) => +e && onChange(e)}
          value={value}
          inputStyle={
            !error
              ? `input input__otp__${inputClassName}`
              : `input input__otp__${inputClassName} input__otp__${inputClassName}__error`
          }
          containerStyle={containerClassName}
          inputType="tel"
          numInputs={minMaxLength}
          renderInput={(props, index) => <input {...props} autoComplete={index === 0 ? 'one-time-code' : 'off'} />}
          shouldAutoFocus
        />
      )}
    />
  );
};

FormInputOtp.defaultProps = defaultProps;
